import { useState, useRef } from "react";
import axios from "axios";
import Header from "../components/Header";

const USER_API = process.env.REACT_APP_USER_SERVICE_URL;
const API_BASE = USER_API + "/users";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");
  const abortRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (status === "loading") return;

    setStatus("loading");
    setMessage("");

    // Cancel previous request if user submits quickly
    if (abortRef.current) {
      abortRef.current.abort();
    }
    abortRef.current = new AbortController();

    try {
      const response = await axios.post(
        `${API_BASE}/auth/reset-password`,
        { email }, // backend expects { email }
        { signal: abortRef.current.signal },
      );
      console.log(response);

      // Use message returned from backend
      const backendMessage =
        response.data?.message ||
        "If an account with this email exists, a password reset link has been sent.";

      setStatus("success");
      setMessage(backendMessage);

      // Reset the input field
      setEmail("");
    } catch (error) {
      if (axios.isCancel(error)) return;

      setStatus("error");
      setMessage(
        error.response?.data?.message ||
          "Unable to process your request. Please try again later.",
      );
    }
  };

  return (
    <>
      <Header hideExtras />

      <main
        id="main-content"
        style={{
          maxWidth: 420,
          margin: "4rem auto",
          padding: "2rem",
          border: "1px solid #e5e7eb",
          borderRadius: 8,
        }}
      >
        <h2 style={{ marginBottom: "0.5rem" }}>Reset your password</h2>

        <p style={{ marginBottom: "1.5rem", color: "#6b7280" }}>
          Enter your email address and we’ll send you a password reset link.
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <label htmlFor="email" style={{ display: "block", marginBottom: 6 }}>
            Email address
          </label>

          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={status === "loading"}
            aria-describedby="reset-message"
            style={{
              width: "100%",
              padding: "10px",
              marginBottom: "12px",
              borderRadius: 4,
              border: "1px solid #d1d5db",
            }}
          />

          <button
            type="submit"
            disabled={status === "loading"}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: 4,
              border: "none",
              backgroundColor: status === "loading" ? "#9ca3af" : "#2563eb",
              color: "#fff",
              cursor: status === "loading" ? "not-allowed" : "pointer",
            }}
          >
            {status === "loading" ? "Sending..." : "Send reset link"}
          </button>
        </form>

        {message && (
          <p
            id="reset-message"
            role="status"
            aria-live="polite"
            style={{
              marginTop: "1rem",
              color: status === "error" ? "#dc2626" : "#065f46",
            }}
          >
            {message}
          </p>
        )}
      </main>
    </>
  );
}
